import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormToggle from "Root/profile/components/common/FormToggle";
import { LoadFutureOrdersThunk, UpdateFutureOrdersThunk } from "Root/profile/redux/thunkCreators/orders/futureOrders";
import { useTracking } from "react-tracking";
import { SubscriptionV2 } from "Root/profile/utils/trackingEnums";
import nextOrderStyles from "../NextOrder/style.module.css";
import styles from "./style.module.scss";
import { MDYDate } from "../../utils";
import posthog from "posthog-js";
const FutureOrders = ({ extraClassName = "" }) => {
    const [loading, setLoading] = useState(false);
    const [futureOrdersArr, setFutureOrdersArr] = useState([]);
    const dispatch = useDispatch();
    const futureOrders = useSelector((state) => state.ordersInfo.futureOrders);
    const reduxStorageIsEmpty = useSelector((state) => state.checkStore.subscription);
    const toggleLoading = () => {
        setLoading(false);
    };
    const { trackEvent } = useTracking();
    const trackSkipNextOrder = (orderIndex) => {
        trackEvent({
            funComponent: SubscriptionV2.Future_orders,
            event: `${SubscriptionV2.skip_futureOrder}__skipped_order=${orderIndex}`,
        });
    };
    const onChange = (value, name, index) => {
        const copyFutureOrders = JSON.parse(JSON.stringify(futureOrdersArr));
        const selectedFutureOrder = copyFutureOrders.find((item) => item.order_number.toString() === name);
        const selectedFutureOrderIndex = copyFutureOrders.findIndex((obj) => obj.order_number.toString() === name);
        if (selectedFutureOrder) {
            selectedFutureOrder.is_on = value;
            copyFutureOrders[selectedFutureOrderIndex] = selectedFutureOrder;
            setFutureOrdersArr(copyFutureOrders);
            setLoading(true);
            dispatch(UpdateFutureOrdersThunk(copyFutureOrders, index, () => {
                toggleLoading();
            }));
            trackSkipNextOrder(Number(index + 1));
            if (value) {
                posthog?.capture("order_skipped", { order_number: name, index: index + 1 });
            }
            else {
                posthog?.capture("order_unskipped", { order_number: name, index: index + 1 });
            }
        }
    };
    useEffect(() => {
        if (reduxStorageIsEmpty) {
            dispatch(LoadFutureOrdersThunk());
        }
    }, []);
    useEffect(() => {
        setFutureOrdersArr(futureOrders);
    }, [futureOrders]);
    return (_jsx("div", { className: `${styles[extraClassName]} ${nextOrderStyles.next_order}`, children: _jsx("div", { children: futureOrders.map((item, i) => (_jsx("div", { className: styles.future_orders_items, children: _jsx("div", { className: styles.future_orders_item, children: !item.is_processing && (_jsx(FormToggle, { checked: item.is_on, id: item.id.toString(), name: item.order_number.toString(), onChange: (value, name) => onChange(value, name, i), children: item.is_processing ? (_jsxs("div", { className: styles.processing_order_wrapper, children: [_jsx("span", { style: { color: item.is_processing ? "rgba(51, 51, 51, 0.5)" : "#333" }, className: nextOrderStyles.order__summary_item_title, children: new Date(MDYDate(item.order_date)).toLocaleDateString() }), _jsx("span", { className: styles.processing_order, children: "Processing, can no longer modify" })] })) : item.is_on ? (_jsx("span", { className: nextOrderStyles.order__summary_item_title, children: new Date(item.order_date).toLocaleDateString() })) : (_jsxs("div", { className: styles.processing_order_wrapper, children: [_jsx("span", { className: nextOrderStyles.order__summary_item_title, children: new Date(item.order_date).toLocaleDateString() }), _jsx("span", { className: styles.processing_order, children: "Skipped" })] })) })) }) }, item.id))) }) }));
};
export default FutureOrders;
